import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const MandatoryPublicDisclosure = () => {
  const homeMenu = [
    { label: "Latest Update", link: "/news" },
    { label: "Testimonials", link: "/testimonial" },
    { label: "School Calendar", link: "/calender" },
    { label: "CBSE Circulars", link: "/circular" },
    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
    { label: "Carpe Diem'22", link: "/carpediem" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-latest-update.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Mandatory Public Disclosure"
                breadEnd="Mandatory Public Disclosure"
                breadMid="Mandatory Public Disclosure"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <ul className="admission-list  latest-update">
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/COMPOSITE_FEE-2026.pdf"
                  >
                    COMPOSITE FEE 2026-27
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/result-x-and-xii.pdf"
                  >
                    RESULT X & XII
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/planner-2025.pdf"
                  >
                    PLANNER 2025
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/MEMBERS-OF-MANAGING-COMMITTEE.pdf"
                  >
                    School Managing Committee
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/rev092023355-recognition.pdf"
                  >
                    REV092023355- RECOGNITION
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/BOOKLIST-FS-1-III-(2025-26).pdf"
                  >
                    BOOKLIST ClASS: FS 1 - III
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/booklist-IV-VIII.pdf"
                  >
                    BOOKLIST ClASS: IV-VIII
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/GRADE-IX-XII-(2025-26).pdf"
                  >
                    BOOKLIST ClASS: IX-XII
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/GRIEVANCE-REDRESSAL-COMMITTEE.pdf"
                  >
                    GRIEVANCE REDRESSAL COMMITTEE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/POSH-COMMITTEE.pdf"
                  >
                    POSH COMMITTEE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/SCHOOL-PROFILE.pdf"
                  >
                    SCHOOL PROFILE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/lvisg-executive-pta-boday-2023-24.pdf"
                  >
                    LVISG Executive PTA Body 2024-25
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/hygiene-certificate-may-2023.pdf"
                  >
                    HYGIENE CERTIFICATE MAY 2023
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/fire-safety-certificate.pdf"
                  >
                    FIRE SAFETY CERTIFICATE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CBSE-Affiliation-Extension-2022-2027.pdf"
                  >
                    CBSE Affiliation Extension 2022-2027
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/REGISTRATION-CERTIFICATE.pdf"
                  >
                    REGISTRATION CERTIFICATE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/NOC-ISSUED-BY-STATE-GOVT.pdf"
                  >
                    NOC ISSUED BY STATE GOVT.
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/RECOGNITION-Certificate.pdf"
                  >
                    RECOGNITION CERTIFICATE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/BUILDING-SAFETY-CERTIFICATE.pdf"
                  >
                    BUILDING SAFETY CERTIFICATE
                  </Link>
                </li>
                <li>
                  <Link target="_blank" rel="noreferrer" to="/staffDetails">
                    STAFF LIST
                  </Link>
                </li>
                <li>
                  <Link target="_blank" rel="noreferrer" to="/">
                    NOC DEO
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/WATER-HEALTH-&-SANITATIO-CERTIFICATE.pdf"
                  >
                    WATER, HEALTH & SANITATION CERTIFICATE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Mandatory-Public-Disclosure-Form.pdf"
                  >
                    MANDATORY PUBLIC DISCLOSURE FORM
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/SANITATION-CERTIFICATE.pdf"
                  >
                    SANITATION CERTIFICATE
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/POCSO-ACT.pdf"
                  >
                    POCSO ACT
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default MandatoryPublicDisclosure;
